import { buildApiUrl } from '../utils/apiConfig';
import { BioSection } from '../types/aboutBios';

export async function fetchAboutBios(): Promise<BioSection | null> {
    try {
        const response = await fetch(buildApiUrl('api/cms/about/bios'), {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Failed to fetch about bios: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching about bios:', error);
        return null;
    }
}
